React = require 'react/addons'
Router = require 'react-router'

{ Route, DefaultRoute, NotFoundRoute } = Router

App = require('./components/app.cjsx')
AgeGate = require './components/age-gate'
Video = require './components/video'
Home = require './components/home'
Product = require './components/product'
Film = require './components/film'
About = require('./components/about')

# Follow = require './components/follow'
# <Route name="follow" handler={Follow}/>

routes = (
  React.createElement(Route, {"path": "/", "handler": (App)},
    React.createElement(DefaultRoute, {"name": "home", "handler": (Home)}),
    React.createElement(NotFoundRoute, {"handler": (Home)}),
    React.createElement(Route, {"name": "age-gate", "handler": (AgeGate)}),
    React.createElement(Route, {"name": "about", "handler": (About)}),
    React.createElement(Route, {"name": "film", "handler": (Film)}),
    React.createElement(Route, {"name": "product", "path": "/product/:productId", "handler": (Product)}),
    React.createElement(Route, {"name": "video", "path": "/video/:videoId", "handler": (Video)})
  )
)

location = Router.HistoryLocation

if NODE_ENV isnt 'production'
  location = Router.HashLocation

Router.run routes, location, (Handler) ->
  React.render React.createElement(Handler, null), document.body



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/routes.cjsx
 **/